import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import * as i0 from '@angular/core';
import { PLATFORM_ID, Injectable, Inject, NgModule } from '@angular/core';

class PlatformService {
    constructor(platformId) {
        this.platformId = platformId;
    }
    get isBrowser() {
        return isPlatformBrowser(this.platformId);
    }
    get isServer() {
        return isPlatformServer(this.platformId);
    }
}
PlatformService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PlatformService, deps: [{ token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Injectable });
PlatformService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PlatformService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: PlatformService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; } });

class JWTService {
    constructor(_platformService) {
        this._platformService = _platformService;
    }
    /**
     * JWT decode
     * @param accessToken The access  token
     */
    parseJwt(accessToken) {
        try {
            if (accessToken) {
                const base64Url = accessToken.split('.')[1];
                const base64 = base64Url.replace('-', '+').replace('_', '/');
                if (this._platformService.isServer) {
                    return JSON.parse(Buffer.from(base64, 'base64').toString()) || null;
                }
                return JSON.parse(atob(base64)) || null;
            }
            return null;
        }
        catch (err) {
            console.error('Invalid format. Can not parse the access token');
        }
    }
    isValidToken(currentToken, newToken) {
        try {
            if (currentToken && newToken) {
                const expCurrentToken = this.parseJwt(currentToken).exp;
                const expNewToken = this.parseJwt(newToken).exp;
                if (expNewToken > expCurrentToken) {
                    return true;
                }
                console.error('Invalid expire data', expNewToken, expCurrentToken);
            }
            else {
                console.error('New token empty');
                return false;
            }
        }
        catch (error) {
            console.error('Failed to parse a new token');
        }
    }
}
JWTService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: JWTService, deps: [{ token: PlatformService }], target: i0.ɵɵFactoryTarget.Injectable });
JWTService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: JWTService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: JWTService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: PlatformService }]; } });

// TODO: agregar definiciones del SSR template
class LocalStorage {
    clear() { }
    getItem(_key) {
        return undefined;
    }
    key(_index) {
        return undefined;
    }
    removeItem(_key) { }
    setItem(_key, _value) { }
}
class LocalStorageService {
    constructor(_platformService) {
        this._platformService = _platformService;
        if (this._platformService.isBrowser) {
            this.storage = localStorage;
        }
        else {
            this.storage = new LocalStorage();
        }
    }
    getItem(key) {
        try {
            return JSON.parse(this.storage.getItem(key));
        }
        catch (e) {
            console.error('Error getting data from localStorage', e);
            return null;
        }
    }
    key(index) {
        return this.storage.key(index);
    }
    setItem(key, value) {
        try {
            this.storage.setItem(key, JSON.stringify(value));
        }
        catch (e) {
            console.error('Error saving to localStorage', e);
        }
    }
    removeItem(key) {
        this.storage.removeItem(key);
    }
    clear() {
        this.storage.clear();
    }
}
LocalStorageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LocalStorageService, deps: [{ token: PlatformService }], target: i0.ɵɵFactoryTarget.Injectable });
LocalStorageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LocalStorageService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: LocalStorageService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: PlatformService }]; } });

const COMMON_PROVIDERS = [
    JWTService,
    PlatformService,
    LocalStorageService,
];
class NGFCommonModule {
    static forRoot() {
        return {
            ngModule: NGFCommonModule,
        };
    }
}
NGFCommonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NGFCommonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NGFCommonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: NGFCommonModule });
NGFCommonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NGFCommonModule, providers: [...COMMON_PROVIDERS] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: NGFCommonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    exports: [],
                    providers: [...COMMON_PROVIDERS],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { COMMON_PROVIDERS, JWTService, LocalStorageService, NGFCommonModule, PlatformService };
